export default "__VITE_ASSET__B_$MVOtm__"